// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"718":"7e2031","811":"23b244"}[chunkId] + ".js";
};